<div class="card click-interaction" (click)="navigate()">
    <div class="card-title">
        <h2 *ngIf="title.useLargeTitle"><i *ngIf="title.icon"
                class="fas {{title.icon}} mr-4"></i><span>{{title.text}}</span></h2>
        <h3 *ngIf="!title.useLargeTitle"><i *ngIf="title.icon"
                class="fas {{title.icon}} mr-4"></i><span>{{title.text}}</span></h3>
    </div>
    <div *ngIf="isStatusPillsVisible() || isLoadingStatusPills == true" class="card-body mt-4">
        <div *ngIf="isLoadingStatusPills == true" class="mr-2 fas fa-spinner fa-spin text-info"></div>
        <ng-container *ngFor="let eFileStatusPill of eFileStatusPills">
            <span *ngIf="eFileStatusPill.total > 0 && eFileStatusPill.isVisible" class="badge badge-{{eFileStatusPill.eFileStatus.indicator}} mr-3 mb-2">{{eFileStatusPill.eFileStatus.name}} - {{eFileStatusPill.total}}</span>
        </ng-container>
    </div>
</div>